import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'ew-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
})
export class EmailVerificationComponent {
  constructor(private API: ApiService, private AUTH: AuthService) {}

  resendVerificationEmail(): void {
    this.API.post('/auth/verification-email/', {}).subscribe((data) => {
      this.API.alertService.success(
        'accountVerification:responseSuccessEmailVerified',
      );
    });
  }

  logout(): void {
    localStorage.removeItem('company');
    this.AUTH.logout();
  }
}
